module.exports = __webpack_public_path__ + "2256ee07c7a1a366e5bac1c3fcb8e216.ttf";